module.exports = __webpack_public_path__ + "static/img/info-circle.3d702569.svg";